<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-noticeForm">
                <el-form-item label="图片标题：" prop="title">
                    <el-input v-model="ruleForm.title" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="图片：" prop="imageUrl">
                    <div>
                        <el-upload
                            class="avatar-uploader"
                            ref="upload"
                            accept="image/*"
                            :action="upUrl"
                            :name="'file'"
                            :data="QiniuData"
                            :before-upload="beforeAvatarUpload"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess">
                            <el-image
                                class="avatar"
                                v-if="ruleForm.imageUrl"
                                :src="ruleForm.imageUrl"
                                fit="contain"></el-image>
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="submit-btn" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>

import {FILE_UPLOAD_HOST_QN} from "@/config";
import {getLoveBanner, saveLoveBanner} from "@/api/tongji";
import {getQNToken} from "@/utils/CryptoJS";
import {getQNFileKey} from "@/utils/utils";
import {getQiniuUrl} from "@/api/common";

export default {
    name: "flove_image-edit",
    data() {
        return {
            id: '',
            moldList: [],
            fileList: [],
            upUrl: FILE_UPLOAD_HOST_QN,
            ruleForm: {
                title: '',
                imageUrl: '',
            },
            rules: {
                title: [{required: true, message: '请输入', trigger: 'blur'},],
                imageUrl: [{required: true, message: '请上传图片', trigger: 'change'},],

            },
            QiniuData: {
                fname: '', //  文件名
                key: '', //文件名字处理
                token: getQNToken() //七牛云token
            },
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                token: this.user.token,
                addWatermark: 0
            };
        },
    },
    created() {
        this.$emit("setIndex", '/home/flove_image', "双暖为老 / 图片编辑", true);
        this.id = Number(this.$route.params.id || 0)
        if (this.id) this.getDetail()
    },
    components: {},
    methods: {
        //  获取列表
        async getDetail() {
            const res = await getLoveBanner(this.id)
            this.ruleForm = {
                title: res.data.name,
                imageUrl: res.data.image,
            }
        },
        //  提交视频
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitQuestion()
                }
            });
        },
        async submitQuestion() {
            let _state = await saveLoveBanner(
                this.id,
                this.ruleForm.title,
                this.ruleForm.imageUrl,
            )
            this.$message.success(_state.info)
            this.$router.go(-1)
        },
        //  上传钱判断
        beforeAvatarUpload(file) {
            this.QiniuData.fname = file.name;
            this.QiniuData.key = getQNFileKey(`${new Date().getTime()}${file.name}`)
        },
        //  上传成功
        async handleAvatarSuccess(res, file) {
            // if (res.status === 200) {
                let _data = await getQiniuUrl(res.key)
                this.ruleForm.imageUrl = _data.data.url
            // } else {
            //     this.$message.error(res.info)
            //     this.$refs['upload'].clearFiles()
            // }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin: 0 auto;
    display: block;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 150px;
    height: 180px;
    display: block;
    border: 1px dashed #d9d9d9;

    &.active {
        width: 400px;
        height: 300px;
    }
}
</style>
